import { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Messages
import { pageMessages } from 'app/store/page/page.messages';
// Mui
import { Tooltip } from '@mui/material';
// Hooks
import useToggle from 'app/hooks/useToggle';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
// Dialogs
import TagPickerDialog from 'app/dialogs/TagPickerDialog';
// Utils
import usePagesUtilities from '../utils/usePagesUtilities';

const TagPickerButton = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const selectedPageIds = useAppSelector(selectSelectedPageIds);

  const { getPagesByIds, updatePagesTag } = usePagesUtilities();

  const { open, toggle } = useToggle();

  const handleTagPickerDialogClose = useCallback((tag?:string | null) => {
    if ( typeof tag === 'undefined' ){
      toggle();
      return;
    }
    const pages = getPagesByIds(selectedPageIds);
    const updatedPages = updatePagesTag(pages, tag);
    const message = tag
      ? updatedPages.length > 1 ? pageMessages.updatePagesTag : pageMessages.updatePageTag
      : updatedPages.length > 1? pageMessages.removePagesTag : pageMessages.removePageTag;
    dispatch(PageActions.patchPages(updatedPages, message));
    // Close tag picker dialog
    toggle();

    dispatch(MixpanelActions.handleCasePagesBulkActionClick({ action: 'tag', numberOfPages: updatedPages.length }));
  }, [dispatch, selectedPageIds, getPagesByIds, updatePagesTag, toggle]);

  return (
    <Fragment>
      <Tooltip title="Assign tag">
        <IconButton
          name="Assign tag"
          onClick={toggle}
        ><Icon icon="tag_assign" /></IconButton>
      </Tooltip>
      {open ? (
        <TagPickerDialog
          open={open}
          onClose={handleTagPickerDialogClose}
          title={t('pages.search.addPagesTag')}
        />
      ) : null}
    </Fragment>
  )
}

export default TagPickerButton;
